import styled from "styled-components/macro";
import { useState } from "react";
import { useStopwatch } from "react-timer-hook";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Draggable from "react-draggable";
import _ from "lodash";
import { useTranslation, withTranslation } from "react-i18next";
import ModalConfirm from "components/Modal/ModalConfirmStateIn";

import "./numpad.scss";
import Spin from "antd/lib/spin";
import Popover from "antd/lib/popover";
import Typography from "antd/lib/typography";
import Menu from "antd/lib/menu";
import Dropdown from "antd/lib/dropdown";
import Input from "antd/lib/input";
import Button from "antd/lib/button";
import Tooltip from "antd/lib/tooltip";
import Table from "antd/lib/table";
import { SearchOutlined } from "@ant-design/icons";

import ImgConfirm from "assets/icons/common/confirm.png";
// import PhoneReady from "assets/icons/numpad/phone_ready.svg";
// import PhoneNotReady from "assets/icons/numpad/phone_not_ready.svg";
import PhoneNotReady from "assets/icons/LayoutVer3/CallOff.svg";
import PhoneReady from "assets/icons/LayoutVer3/CallOn.svg";
import DeleteNumber from "assets/icons/numpad/delete_input.svg";
import DeclineCall from "assets/icons/numpad/decline_call.svg";
import AnswerCall from "assets/icons/numpad/answer_call.svg";
import TransferAction from "assets/icons/numpad/transfer_action.svg";
import DisconnectExt from "assets/icons/numpad/disconnect.svg";
import ConferenceAction from "assets/icons/numpad/conference_action.svg";

import CallIcon from "assets/icons/numpad/CallIcon.svg";
import CloseIcon from "assets/icons/numpad/CloseIcon.svg";
import ConferenceIcon from "assets/icons/numpad/ConferenceIcon.svg";
import ConsultIcon from "assets/icons/numpad/ConsultIcon.svg";
import FullScreenExitIcon from "assets/icons/numpad/FullScreenExitIcon.svg";
import FullScreenIcon from "assets/icons/numpad/FullScreenIcon.svg";
import HoldIcon from "assets/icons/numpad/HoldIcon.svg";
import NumpadIcon from "assets/icons/numpad/NumpadIcon.svg";
import OffIcon from "assets/icons/numpad/OffIcon.svg";
// import RemoveNumberIcon from "assets/icons/numpad/RemoveNumberIcon.svg";
import TransferIcon from "assets/icons/numpad/TransferIcon.svg";
import PhoneReadyIcon from "assets/icons/numpad/PhoneReadyIcon.svg";
import PhoneNotReadyIcon from "assets/icons/numpad/PhoneNotReadyIcon.svg";
import ArrowDownIcon from "assets/icons/numpad/ArrowDownIcon.svg";
import AvatarIcon from "assets/icons/numpad/AvatarIcon.png";

import { Notification } from "components/Notification/Noti";
import { FE_URL } from "constants/constants";
import VoiceBiometric from "components/VoiceBiometric/voiceBiometric";

import {
  updateStatusCall,
  updateScreen,
  loadlistStatus,
  loadListReasonCode,
  changeAgentStatus,
  makeCall,
  endCall,
  holdCall,
  unHoldCall,
  loadAgentsOnline,
  transferCall,
  conferenceCall,
  consultCall,
  answerCall,
  updateInteraction,
  updateHold,
  connectExt,
  setAlreadyUseExt,
  disconnectExt,
  storeDataCallCenter,
  loadNewInteraction,
} from "redux/slices/callCenter";

import { callEvent } from "redux/slices/voiceBiometric";

const LoadingComp = (
  <div
    style={{
      width: "36px",
      height: "30px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Spin />
  </div>
);

const LoadingCompMini = (
  <div
    style={{
      width: "32px",
      height: "24px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Spin />
  </div>
);

function PopupNumpad({ dataWebSocket, userDetail }) {
  let dialogID = localStorage.getItem("dialogID");
  let hotLine = localStorage.getItem("hotline");
  let typeCall = localStorage.getItem("typeCall");
  let inCall = localStorage.getItem("inCall");
  let phoneNumber = localStorage.getItem("phoneNumber");
  let statusInCall = localStorage.getItem("statusInCall");
  let screenIncomingCall = localStorage.getItem("incomingCall");
  let screenCall = localStorage.getItem("screenCall");
  let callTime = localStorage.getItem("call_time");

  let inPopupVoice = localStorage.getItem("popup-voice");

  const dispatch = useDispatch();
  const {
    isLoading,
    listStatus,
    initialStatus,
    statusCall,
    screen,
    isHold,
    listAgentsOnline,
    alreadyUseExt,
  } = useSelector((state) => state.callCenterReducer);

  const { Text } = Typography;
  const { Column } = Table;
  const { t } = useTranslation();
  const offsetTimestamp = new Date();
  const { seconds, minutes, hours, pause, reset } = useStopwatch({
    autoStart: true,
    offsetTimestamp: localStorage.getItem("call_time")
      ? offsetTimestamp.setSeconds(
          offsetTimestamp.getSeconds() +
            parseInt(
              (offsetTimestamp.getTime() -
                new Date(localStorage.getItem("call_time")).getTime()) /
                1000
            )
        )
      : offsetTimestamp.setSeconds(offsetTimestamp.getSeconds() + 0),
  });

  const [popupVoice, setPopupVoice] = useState(false);
  const [showVoice, setShowVoice] = useState(false);

  const [isShowConnect, $isShowConnect] = useState(false);
  const [isShowNumpad, setIsShowNumpad] = useState(false);
  const [isShowMenuStatus, setIsShowStatus] = useState(false);
  const [isShowNumpadIncall, setIsShowNumpadInCall] = useState(false);
  const [isMini, setIsMini] = useState(false);
  const [isShowMenuTransfer, setIsShowMenuTransfer] = useState(false);
  const [isShowMenuConference, setIsShowMenuConference] = useState(false);
  const [isShowMenuConsult, setIsShowMenuConsult] = useState(false);
  const [showConfirmDisconnect, $showConfirmDisconnect] = useState(false);

  const [status, setStatus] = useState("");
  const [valueInput, setValueInput] = useState("");
  const [consultList, setConsultList] = useState([]);
  const [activeDrags, setActiveDrags] = useState(0);
  const [valueExt, $valueExt] = useState("");

  const [filterListTransfer, $filterListTransfer] = useState([]);
  const [filterListConsult, $filterListConsult] = useState([]);
  const [valueSearch, setValueSearch] = useState({
    name: "",
    extension: "",
  });
  const [isDisableEndCall, setIsDisableEndCall] = useState(false);

  const handleShowNumpad = () => {
    if (screenCall === "inCall" || screenIncomingCall === "true") {
      setIsShowNumpad(true);
    } else {
      setIsShowNumpad(!isShowNumpad);
    }
  };

  const handleShowConnect = () => {
    $isShowConnect(!isShowConnect);
  };

  const handleShowMenuStatus = () => {
    setIsShowStatus(!isShowMenuStatus);
  };

  const handleShowMenuTransfer = () => {
    setIsShowMenuTransfer(!isShowMenuTransfer);
  };

  const handleShowMenuConference = () => {
    setIsShowMenuConference(!isShowMenuConference);
  };

  const handleShowMenuConsult = () => {
    setIsShowMenuConsult(!isShowMenuConsult);
  };

  const handleChangeInput = (e) => {
    setValueInput(e.target.value);
  };

  const hanldeChangeStatus = (reasonCode) => {
    dispatch(
      changeAgentStatus({
        agentStatus: reasonCode,
      })
    );
    handleShowMenuStatus();
  };

  const onDeleteInput = () => {
    let temp = valueInput;
    temp = temp.slice(0, temp.length - 1);
    setValueInput(temp);
  };

  const onClickNumber = (num) => {
    let temp = valueInput + num;
    setValueInput(temp);
  };

  const _onMakeCall = () => {
    if (valueInput !== "") {
      dispatch(
        makeCall({
          phone: valueInput,
        })
      );
    } else {
      Notification("error", "Please input phone number!");
    }
  };

  const _onDeclineCall = () => {
    if (isDisableEndCall) return;

    if (dialogID) {
      dispatch(
        endCall({
          dialogID: dialogID,
        })
      );
    } else {
      dispatch(updateScreen(""));
      setIsShowNumpad(false);
      setPopupVoice(false);
      dispatch(
        storeDataCallCenter({
          phoneInCall: "",
        })
      );
      localStorage.removeItem("dialogID");
      localStorage.removeItem("hotline");
      localStorage.removeItem("typeCall");
      localStorage.removeItem("inCall");
      localStorage.removeItem("statusInCall");
      localStorage.removeItem("phoneNumber");
      localStorage.removeItem("incomingCall");
      localStorage.removeItem("call_time");
      localStorage.removeItem("agent-callName");
      localStorage.removeItem("popup-voice");
      localStorage.removeItem("inforAgentCIF");
      localStorage.removeItem("inforAgentName");
      localStorage.removeItem("inforAgentChoice");
      localStorage.removeItem("statusRegister");
      localStorage.removeItem("statusAuthenManually");
      localStorage.removeItem("screenVoice");
      localStorage.removeItem("statusAuthenAuto");
      localStorage.removeItem("@ucrm_callCenter_phoneInCall");
    }
    setIsDisableEndCall(true);
    setTimeout(() => {
      setIsDisableEndCall(false);
    }, 6000);
  };

  function filterByKey(array, valueSearch, keySearch) {
    const normalizedSearchName = valueSearch
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    return array.filter((item) => {
      const normalizedPersonName = item[keySearch]
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      return normalizedPersonName.includes(normalizedSearchName);
    });
  }

  useEffect(() => {
    if (valueSearch.extension || valueSearch.name) {
      let filteredList;
      let filteredListConsult;
      if (valueSearch.extension) {
        filteredList = filterByKey(
          listAgentsOnline || [],
          valueSearch.extension,
          "extension"
        );
        filteredListConsult = filterByKey(
          consultList || [],
          valueSearch.extension,
          "extension"
        );
      } else {
        filteredList = filterByKey(
          listAgentsOnline || [],
          valueSearch.name,
          "name"
        );
        filteredListConsult = filterByKey(
          consultList || [],
          valueSearch.name,
          "name"
        );
      }

      $filterListTransfer(filteredList);
      $filterListConsult(filteredListConsult);
    } else {
      $filterListTransfer(listAgentsOnline);
      $filterListConsult(consultList);
    }
  }, [consultList, listAgentsOnline, valueSearch]);

  useEffect(() => {
    if (window) {
      window.onbeforeunload = () => {
        setIsMini(false);
        dispatch(updateScreen(""));
        setIsShowNumpad(false);
        setPopupVoice(false);
        dispatch(
          storeDataCallCenter({
            phoneInCall: "",
          })
        );
        setValueSearch({
          name: "",
          extension: "",
        });
        localStorage.removeItem("dialogID");
        localStorage.removeItem("hotline");
        localStorage.removeItem("typeCall");
        localStorage.removeItem("inCall");
        localStorage.removeItem("statusInCall");
        localStorage.removeItem("phoneNumber");
        localStorage.removeItem("@ucrm_callCenter_phoneInCall");
        localStorage.removeItem("incomingCall");
        localStorage.removeItem("call_time");
        localStorage.removeItem("agent-callName");
        localStorage.removeItem("popup-voice");
        localStorage.removeItem("inforAgentCIF");
        localStorage.removeItem("inforAgentName");
        localStorage.removeItem("inforAgentChoice");
        localStorage.removeItem("statusRegister");
        localStorage.removeItem("statusAuthenManually");
        localStorage.removeItem("screenVoice");
        localStorage.removeItem("statusAuthenAuto");
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const _onHoldCall = () => {
    if (isHold) {
      dispatch(
        unHoldCall({
          dialogID: dialogID,
        })
      );
    } else {
      dispatch(
        holdCall({
          dialogID: dialogID,
        })
      );
    }
  };

  const _onLoadAgentsOnline = () => {
    dispatch(
      loadAgentsOnline({
        dialogID: dialogID,
      })
    );
  };

  const _onTransferCall = (extension) => {
    dispatch(
      transferCall({
        transferAgent: extension,
        dialogID: dialogID,
      })
    );
    setIsShowMenuTransfer(false);
    setValueSearch({
      name: "",
      extension: "",
    });
  };

  const _onConferenceCall = (extension) => {
    dispatch(
      conferenceCall({
        conferenceAgent: extension,
        dialogID: dialogID,
      })
    );
    setIsShowMenuConference(false);
    setValueSearch({
      name: "",
      extension: "",
    });
  };

  const _onConsultCall = (record) => {
    let tempConsult = [...consultList];
    tempConsult.push(record);
    setConsultList(tempConsult);

    dispatch(
      consultCall({
        extensionDest: record.extension,
        dialogID: dialogID,
      })
    );
    setIsShowMenuConsult(false);
    setValueSearch({
      name: "",
      extension: "",
    });
  };

  const _onAnswerCall = () => {
    dispatch(
      answerCall({
        dialogID: dialogID,
      })
    );
  };

  const _onDisconnectExt = () => {
    $valueExt("");
    $isShowConnect(false);
    $showConfirmDisconnect(true);
  };

  const menuStatus = (
    <MenuStatus>
      {_.map(listStatus, (item) => (
        <MenuStatusItem
          ready={item.reasonName === "Ready"}
          key={item.reasonCode}
          onClick={() => hanldeChangeStatus(item.reasonCode)}
        >
          <Text
            ellipsis={{ tooltip: item.reasonName }}
            style={{ width: "177px" }}
          >
            {item.reasonName}
          </Text>
        </MenuStatusItem>
      ))}

      {_.get(userDetail, "allow_dynamic_extension", false) && (
        <Menu.Item
          onClick={_onDisconnectExt}
          style={{
            background: "#ED2D2D",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            marginTop: "16px",
          }}
        >
          <img src={DisconnectExt} alt="" style={{ marginRight: "8px" }} />
          <span style={{ color: "#fff", fontSize: "16px" }}>
            {t("common.disconnect")}
          </span>
        </Menu.Item>
      )}
    </MenuStatus>
  );

  const menuListAgents = (type) => {
    return (
      <MenuTransfer>
        <TitleTransfer>
          {type === "transfer"
            ? "Transfer a call to another number"
            : type === "conference"
            ? "Conference a call"
            : "Consult a call"}
        </TitleTransfer>
        <Table
          pagination={false}
          dataSource={
            typeCall === "1" && type === "conference"
              ? filterListConsult
              : filterListTransfer
          }
          scroll={{ x: "max-content", y: 400 }}
        >
          <Column
            title="Agent"
            dataIndex="name"
            key="name"
            width="371px"
            render={(text) => (
              <Text ellipsis={{ tooltip: text }} style={{ width: "339px" }}>
                {text}
              </Text>
            )}
            filterDropdown={() => {
              return (
                <WrapSearch>
                  <Input
                    autoFocus
                    placeholder="Search by agent"
                    onChange={(e) => {
                      let tmp = { ...valueSearch };
                      tmp.name = e.target.value;
                      setValueSearch(tmp);
                    }}
                    value={valueSearch.name}
                  />
                </WrapSearch>
              );
            }}
            filterIcon={() => <SearchOutlined />}
          />
          <Column
            title="Extension"
            dataIndex="extension"
            key="extension"
            width="163px"
            render={(text) => (
              <Text ellipsis={{ tooltip: text }} style={{ width: "131px" }}>
                {text}
              </Text>
            )}
            filterDropdown={() => {
              return (
                <WrapSearch>
                  <Input
                    autoFocus
                    placeholder="Search by extension"
                    onChange={(e) => {
                      let tmp = { ...valueSearch };
                      tmp.extension = e.target.value;
                      setValueSearch(tmp);
                    }}
                    value={valueSearch.extension}
                  />
                </WrapSearch>
              );
            }}
            filterIcon={() => <SearchOutlined />}
          />
          <Column
            title=""
            dataIndex="action"
            key="action"
            width="72px"
            render={(text, record) => (
              <Tooltip title={type === "transfer" ? "Transfer" : "Add"}>
                <ActionTransfer
                  // onClick={() => _onTransferCall(record.extension)}
                  onClick={() => {
                    type === "transfer"
                      ? _onTransferCall(record.extension)
                      : type === "conference"
                      ? _onConferenceCall(record.extension)
                      : _onConsultCall(record);
                  }}
                >
                  <img
                    src={
                      type === "transfer" ? TransferAction : ConferenceAction
                    }
                    alt="transfer"
                  />
                </ActionTransfer>
              </Tooltip>
            )}
          />
        </Table>
      </MenuTransfer>
    );
  };

  const formatTime = (time) => {
    return String(time).padStart(2, "0");
  };

  const onStart = () => {
    let temp = activeDrags;
    temp = ++temp;
    setActiveDrags(temp);
  };

  const onStop = () => {
    let temp = activeDrags;
    temp = --temp;
    setActiveDrags(--temp);
  };

  const onChangeExt = (e) => {
    $valueExt(e.target.value);
  };

  const _onConnectExt = () => {
    if (valueExt) {
      dispatch(
        connectExt({
          ext: valueExt,
          force_connect: 0,
          userID: _.get(userDetail, "_id"),
        })
      );
      $isShowConnect(false);
    }
  };

  useEffect(() => {
    if (userDetail.use_cti) {
      dispatch(loadlistStatus());
      dispatch(loadListReasonCode({}));
    }
  }, [dispatch, userDetail]);

  useEffect(() => {
    setStatus(initialStatus);
  }, [initialStatus]);

  useEffect(() => {
    if (statusCall !== null) {
      localStorage.setItem("statusInCall", statusCall);
    }
  }, [statusCall]);

  useEffect(() => {
    if (screen !== null) {
      localStorage.setItem("screenCall", screen);
    }
  }, [screen]);

  useEffect(() => {
    if (Object.keys(dataWebSocket).length > 0) {
      switch (dataWebSocket.event) {
        case "check_customer_registered_offcall":
          if (dataWebSocket.data.full_name !== null) {
            localStorage.setItem(
              "inforAgentName",
              dataWebSocket.data.full_name
            );
          }
          if (dataWebSocket.data.cif !== null) {
            localStorage.setItem("inforAgentCIF", dataWebSocket.data.cif);
          }
          localStorage.setItem(
            "inforAgentChoice",
            dataWebSocket.data.last_choice
              ? dataWebSocket.data.last_choice
              : "Chưa có"
          );

          if (
            dataWebSocket.data.code === "M_Customer_Not_Found" ||
            dataWebSocket.data.code === "M_Customer_Not_Registered_Voice" ||
            dataWebSocket.data.code === "N_Customer_Not_Registered_Voice_01" ||
            dataWebSocket.data.code === "M_Customer_Decline_Registered_Voice" ||
            dataWebSocket.data.code === "M_VoiceRegistrationFailed_Failed"
          ) {
            localStorage.setItem("statusRegister", "Chưa đăng ký");
            localStorage.setItem("screenVoice", "notRegister");
          } else if (
            dataWebSocket.data.code === "N_Customer_Synthesizing_Voice"
          ) {
            localStorage.setItem("statusRegister", "Chờ kết quả");
            localStorage.setItem("screenVoice", "waiting");
            localStorage.setItem("statusAuthenAuto", "waiting");
          } else if (
            dataWebSocket.data.code === "N_Customer_Registered_Voice"
          ) {
            localStorage.setItem("statusRegister", "Đã đăng ký");
            localStorage.setItem("screenVoice", "alreadyRegister");
            localStorage.setItem("statusAuthenAuto", "waiting");
          } else {
            Notification("error", dataWebSocket.data.message);
          }
          break;

        case "Change status":
          setStatus(dataWebSocket.data.reasonName);

          if (dataWebSocket.data.reasonName === "Wrap-Up") {
            dispatch(updateStatusCall("Wrap-up"));
            reset();
          }

          break;

        case "Ended":
          pause();
          dispatch(updateStatusCall("Ended"));
          dispatch(updateHold(false));

          setTimeout(function () {
            setIsMini(false);
            reset();
            pause();
            setIsShowNumpad(false);
            setPopupVoice(false);
            dispatch(updateScreen(""));
            dispatch(
              storeDataCallCenter({
                phoneInCall: "",
              })
            );
            setValueSearch({
              name: "",
              extension: "",
            });
            localStorage.removeItem("dialogID");
            localStorage.removeItem("hotline");
            localStorage.removeItem("typeCall");
            localStorage.removeItem("inCall");
            localStorage.removeItem("statusInCall");
            localStorage.removeItem("phoneNumber");
            localStorage.removeItem("incomingCall");
            localStorage.removeItem("call_time");
            localStorage.removeItem("agent-callName");
            localStorage.removeItem("popup-voice");
            localStorage.removeItem("inforAgentCIF");
            localStorage.removeItem("inforAgentName");
            localStorage.removeItem("inforAgentChoice");
            localStorage.removeItem("statusRegister");
            localStorage.removeItem("statusAuthenManually");
            localStorage.removeItem("screenVoice");
            localStorage.removeItem("statusAuthenAuto");
            localStorage.removeItem("@ucrm_callCenter_phoneInCall");
          }, 2000);

          break;

        case "Outgoing call":
        case "Incoming call":
          if (dataWebSocket.event === "Incoming call") {
            dispatch(updateScreen("incomingCall"));
            dispatch(updateStatusCall("Incoming call"));
            localStorage.setItem("incomingCall", "true");
          }

          if (dataWebSocket.event === "Outgoing call") {
            dispatch(updateStatusCall("Outgoing call"));
            localStorage.setItem("inCall", "true");
            dispatch(updateScreen("inCall"));
          }

          localStorage.setItem("agent-callName", dataWebSocket.data.username);
          localStorage.setItem("phoneNumber", dataWebSocket.data.phone);
          localStorage.setItem(
            "@ucrm_callCenter_phoneInCall",
            dataWebSocket.data.phone
          );
          localStorage.setItem("dialogID", dataWebSocket.data?.callID);
          localStorage.setItem("hotline", dataWebSocket.data.hotline);
          localStorage.setItem("typeCall", dataWebSocket.data.type_call);

          if (dataWebSocket.data.data.length === 1) {
            localStorage.setItem(
              "dataCall",
              JSON.stringify(dataWebSocket.data)
            );
            localStorage.setItem("popup-voice", "true");

            if (userDetail?.use_voice_biometric) {
              dispatch(
                callEvent({
                  voice_biometric_event: "check_customer_registered_offcall",
                  phone_incoming: dataWebSocket.data.phone,
                  third_party_id: dataWebSocket.data.third_party_id,
                  record_id: dataWebSocket.data.data[0]._id,
                  object_id: dataWebSocket.data.object_id,
                  agent_name: dataWebSocket.data.username,
                })
              );
            }

            if (dataWebSocket.current_session === dataWebSocket.last_session) {
              dispatch(
                updateInteraction({
                  call_id: dataWebSocket.data.third_party_id,
                  record_id: dataWebSocket.data.data[0]._id,
                  object_id: dataWebSocket.data.object_id,
                  extension: dataWebSocket.data.extension,
                  run_workflow_interaction: false,
                  is_popup_multiple: false,
                  ...dataWebSocket.data,
                })
              );

              dispatch(
                loadNewInteraction({
                  third_party_id: dataWebSocket.data.third_party_id,
                })
              );

              const isPageOpen = localStorage.getItem(
                "@ucrm_callCenter_pageIsOpen"
              );
              const dataCallCenter = localStorage.getItem(
                "@ucrm_callCenter_data"
              );

              if (dataCallCenter) {
                let newDataCallCenter = [...JSON.parse(dataCallCenter)];
                if (newDataCallCenter.length === 7) {
                  newDataCallCenter.shift();
                }

                dispatch(
                  storeDataCallCenter({
                    dataCallCenter: _.uniqBy(
                      [...newDataCallCenter, dataWebSocket.data],
                      "third_party_id"
                    ),
                    phoneInCall: dataWebSocket.data.third_party_id,
                  })
                );
                localStorage.setItem(
                  "@ucrm_callCenter_data",
                  JSON.stringify(
                    _.uniqBy(
                      [...newDataCallCenter, dataWebSocket.data],
                      "third_party_id"
                    )
                  )
                );
              } else {
                dispatch(
                  storeDataCallCenter({
                    dataCallCenter: [dataWebSocket.data],
                    phoneInCall: dataWebSocket.data.third_party_id,
                  })
                );
                localStorage.setItem(
                  "@ucrm_callCenter_data",
                  JSON.stringify([dataWebSocket.data])
                );
              }

              if (isPageOpen === "true") {
                console.log("Da mo");
              } else {
                console.log("Chua mo");
                window.open(`${FE_URL}/call-center`);
              }
            }
          } else if (dataWebSocket.data.data.length > 1) {
            localStorage.setItem("popup-voice", "true");
            localStorage.setItem(
              "dataCall",
              JSON.stringify(dataWebSocket.data)
            );

            if (dataWebSocket.current_session === dataWebSocket.last_session) {
              const isPageOpen = localStorage.getItem(
                "@ucrm_callCenter_pageIsOpen"
              );
              const dataCallCenter = localStorage.getItem(
                "@ucrm_callCenter_data"
              );

              if (dataCallCenter) {
                let newDataCallCenter = [...JSON.parse(dataCallCenter)];
                if (newDataCallCenter.length === 7) {
                  newDataCallCenter.shift();
                }

                dispatch(
                  storeDataCallCenter({
                    dataCallCenter: _.uniqBy(
                      [...newDataCallCenter, dataWebSocket.data],
                      "third_party_id"
                    ),
                    phoneInCall: dataWebSocket.data.third_party_id,
                  })
                );
                localStorage.setItem(
                  "@ucrm_callCenter_data",
                  JSON.stringify(
                    _.uniqBy(
                      [...newDataCallCenter, dataWebSocket.data],
                      "third_party_id"
                    )
                  )
                );
              } else {
                dispatch(
                  storeDataCallCenter({
                    dataCallCenter: [dataWebSocket.data],
                    phoneInCall: dataWebSocket.data.third_party_id,
                  })
                );
                localStorage.setItem(
                  "@ucrm_callCenter_data",
                  JSON.stringify([dataWebSocket.data])
                );
              }

              if (isPageOpen === "true") {
                console.log("Da mo");
              } else {
                console.log("Chua mo");
                window.open(`${FE_URL}/call-center`);
              }
            }
          }
          break;

        case "Answered":
          setIsMini(true);
          reset();
          dispatch(updateScreen("inCall"));
          dispatch(updateStatusCall("Talking"));
          localStorage.setItem("inCall", "true");

          if (
            _.get(dataWebSocket, "data.call_start_time", "") &&
            _.get(dataWebSocket, "data.call_start_time") !== null
          ) {
            localStorage.setItem(
              "call_time",
              _.get(dataWebSocket, "data.call_start_time")
            );
          } else {
            localStorage.setItem(
              "call_time",
              _.get(dataWebSocket, "call_start_time")
            );
          }

          localStorage.removeItem("incomingCall");
          break;

        case "Hold":
          dispatch(updateStatusCall("Hold"));
          dispatch(updateHold(true));
          break;

        case "Retrieve":
          dispatch(updateStatusCall("Talking"));
          dispatch(updateHold(false));
          break;

        default:
          break;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataWebSocket, dispatch]);

  useEffect(() => {
    if (inCall === "true" || screenIncomingCall === "true") {
      setIsShowNumpad(true);
    }
  }, [dataWebSocket, dispatch, inCall, screenIncomingCall]);

  useEffect(() => {
    if (inPopupVoice === "true") {
      setPopupVoice(true);
    }
  }, [inPopupVoice]);

  return (
    <>
      {_.get(userDetail, "cti_extension", "") !== null ? (
        <Popover
          content={
            <Draggable onStart={onStart} onStop={onStop}>
              {isMini ? (
                <WrapperMini id="ucrm_numpad_ANSWER">
                  <AvatarMini>
                    <img src={AvatarIcon} alt="avatar" />
                  </AvatarMini>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <PhoneNumber>{phoneNumber}</PhoneNumber>
                    <DurationMini>
                      {Object.keys(dataWebSocket).length > 0 &&
                      callTime &&
                      callTime !== null ? (
                        <>
                          {hours > 0 && <>{formatTime(hours)}:</>}
                          {formatTime(minutes)}:{formatTime(seconds)}
                        </>
                      ) : (
                        <span>00:00</span>
                      )}
                    </DurationMini>
                  </div>

                  <ActionsMini>
                    {isLoading.loadingHold ? (
                      LoadingCompMini
                    ) : (
                      <Tooltip title={isHold ? "Unhold" : "Hold"}>
                        <ActionMini onClick={_onHoldCall} active={isHold}>
                          <img src={HoldIcon} alt="hold" />
                        </ActionMini>
                      </Tooltip>
                    )}

                    {isLoading.loadingTransfer ? (
                      LoadingCompMini
                    ) : (
                      <Dropdown
                        visible={isShowMenuTransfer}
                        onVisibleChange={handleShowMenuTransfer}
                        overlay={menuListAgents("transfer")}
                        placement="bottomCenter"
                        trigger={["click"]}
                      >
                        <Tooltip title="Transfer">
                          <ActionMini
                            onClick={!isShowMenuTransfer && _onLoadAgentsOnline}
                            active={isShowMenuTransfer}
                          >
                            <img src={TransferIcon} alt="transfer" />
                          </ActionMini>
                        </Tooltip>
                      </Dropdown>
                    )}

                    {isLoading.loadingConference ? (
                      LoadingCompMini
                    ) : (
                      <Dropdown
                        visible={isShowMenuConference}
                        onVisibleChange={handleShowMenuConference}
                        overlay={menuListAgents("conference")}
                        placement="bottomCenter"
                        trigger={["click"]}
                      >
                        <Tooltip title="Conference">
                          <ActionMini
                            onClick={
                              !isShowMenuConference && _onLoadAgentsOnline
                            }
                            active={isShowMenuConference}
                          >
                            <img src={ConferenceIcon} alt="conference" />
                          </ActionMini>
                        </Tooltip>
                      </Dropdown>
                    )}

                    {isLoading.loadingConsult ? (
                      LoadingCompMini
                    ) : (
                      <Dropdown
                        visible={isShowMenuConsult}
                        onVisibleChange={handleShowMenuConsult}
                        overlay={menuListAgents("consult")}
                        placement="bottomCenter"
                        trigger={["click"]}
                      >
                        <Tooltip title="Consult">
                          <ActionMini
                            onClick={!isShowMenuConsult && _onLoadAgentsOnline}
                            active={isShowMenuConsult}
                          >
                            <img src={ConsultIcon} alt="consult" />
                          </ActionMini>
                        </Tooltip>
                      </Dropdown>
                    )}

                    <Tooltip title="Numpad">
                      <ActionMini
                        onClick={() => {
                          if (isMini) {
                            setIsMini(false);
                          }

                          setIsShowNumpadInCall(!isShowNumpadIncall);
                        }}
                        active={isShowNumpadIncall}
                      >
                        <img src={NumpadIcon} alt="numpad" />
                      </ActionMini>
                    </Tooltip>
                  </ActionsMini>
                  <ButtonDeclineCallMini
                    disabled={isDisableEndCall}
                    onClick={_onDeclineCall}
                  >
                    {isLoading.loadingEndCall ? (
                      <Spin />
                    ) : (
                      <img
                        src={DeclineCall}
                        alt="declineCall"
                        style={{ width: "16px", height: "16px" }}
                      />
                    )}
                  </ButtonDeclineCallMini>
                  <WrapExit>
                    <img
                      onClick={() => setIsMini(false)}
                      src={FullScreenIcon}
                      alt="mini"
                    />
                  </WrapExit>
                </WrapperMini>
              ) : (
                <Wrapper
                  id="ucrm_numpad_RINGING"
                  screen={screenCall}
                  isShowNumpadIncall={isShowNumpadIncall}
                >
                  <Header>
                    <Dropdown
                      visible={isShowMenuStatus}
                      onVisibleChange={handleShowMenuStatus}
                      overlay={menuStatus}
                      trigger={"click"}
                      disabled={
                        screenCall === "inCall" || screenIncomingCall === "true"
                      }
                    >
                      <WrapStatusInPopup>
                        <img
                          src={
                            status === "Ready"
                              ? PhoneReadyIcon
                              : PhoneNotReadyIcon
                          }
                          alt="phone"
                        />
                        <div>
                          <ExtensionInPopup status={status}>
                            <Text
                              ellipsis={{ tooltip: userDetail?.cti_extension }}
                              style={{ maxWidth: "65px" }}
                            >
                              {userDetail?.cti_extension}
                            </Text>
                          </ExtensionInPopup>
                        </div>
                        <img
                          src={ArrowDownIcon}
                          alt="down"
                          style={{
                            transform: isShowMenuStatus
                              ? "rotate(180deg)"
                              : "none",
                            transition: "transform 0.3s",
                            marginLeft: "2px",
                          }}
                        />
                      </WrapStatusInPopup>
                    </Dropdown>
                    <WrapExit>
                      {screenCall === "inCall" && (
                        <img
                          onClick={() => setIsMini(true)}
                          src={FullScreenExitIcon}
                          alt="mini"
                        />
                      )}

                      {screenCall === "inCall" ||
                      screenIncomingCall === "true" ? (
                        <Tooltip title="Bạn ko thể đóng khi đang trong cuộc gọi.">
                          <img src={CloseIcon} alt="exit" />
                        </Tooltip>
                      ) : (
                        <img
                          onClick={() => setIsShowNumpad(false)}
                          src={CloseIcon}
                          alt="exit"
                        />
                      )}
                    </WrapExit>
                  </Header>
                  <Screen isShowMenuStatus={isShowMenuStatus}>
                    {screenCall === "inCall" ? (
                      <CallOut>
                        {isShowNumpadIncall ? (
                          <>
                            <WrapInput
                              isShowNumpadIncall={isShowNumpadIncall}
                              style={{ padding: "0 12px" }}
                            >
                              <Input
                                value={valueInput}
                                onChange={handleChangeInput}
                              />
                              <ButtonDeleteInput
                                onClick={() => onDeleteInput()}
                              >
                                <img src={DeleteNumber} alt="delete" />
                              </ButtonDeleteInput>
                            </WrapInput>
                            <WrapNumber>
                              <Row>
                                <span onClick={() => onClickNumber("1")}>
                                  1
                                </span>
                                <span onClick={() => onClickNumber("2")}>
                                  2
                                </span>
                                <span onClick={() => onClickNumber("3")}>
                                  3
                                </span>
                              </Row>
                              <Row>
                                <span onClick={() => onClickNumber("4")}>
                                  4
                                </span>
                                <span onClick={() => onClickNumber("5")}>
                                  5
                                </span>
                                <span onClick={() => onClickNumber("6")}>
                                  6
                                </span>
                              </Row>
                              <Row>
                                <span onClick={() => onClickNumber("7")}>
                                  7
                                </span>
                                <span onClick={() => onClickNumber("8")}>
                                  8
                                </span>
                                <span onClick={() => onClickNumber("9")}>
                                  9
                                </span>
                              </Row>
                              <Row>
                                <span onClick={() => onClickNumber("*")}>
                                  *
                                </span>
                                <span onClick={() => onClickNumber("0")}>
                                  0
                                </span>
                                <span onClick={() => onClickNumber("#")}>
                                  #
                                </span>
                              </Row>
                            </WrapNumber>
                          </>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "12px 0",
                              gap: "8px",
                            }}
                          >
                            <Avatar>
                              <img src={AvatarIcon} alt="avatar" />
                            </Avatar>

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "calc(100% - 92px)",
                              }}
                            >
                              <PhoneNumber>{phoneNumber}</PhoneNumber>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <StatusCall>{statusInCall}</StatusCall>

                                <Duration>
                                  {Object.keys(dataWebSocket).length > 0 &&
                                    callTime &&
                                    callTime !== null && (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div
                                          style={{
                                            background: "#637381",
                                            borderRadius: "50%",
                                            width: "2px",
                                            height: "2px",
                                            marginRight: "4px",
                                          }}
                                        />
                                        <>
                                          {hours > 0 && (
                                            <>{formatTime(hours)}:</>
                                          )}
                                          {formatTime(minutes)}:
                                          {formatTime(seconds)}
                                        </>
                                      </div>
                                    )}
                                </Duration>
                              </div>
                            </div>

                            <ButtonDeclineCall
                              disabled={isDisableEndCall}
                              onClick={_onDeclineCall}
                            >
                              {isLoading.loadingEndCall ? (
                                <Spin />
                              ) : (
                                <img src={OffIcon} alt="declineCall" />
                              )}
                            </ButtonDeclineCall>
                          </div>
                        )}
                        <Hotline>
                          <span>Hotline: &nbsp;</span>
                          {hotLine !== null && hotLine !== "null" && (
                            <span>{hotLine}</span>
                          )}
                        </Hotline>

                        <Actions>
                          {isLoading.loadingHold ? (
                            LoadingComp
                          ) : (
                            <Tooltip title={isHold ? "Unhold" : "Hold"}>
                              <Action onClick={_onHoldCall} active={isHold}>
                                <img src={HoldIcon} alt="hold" />
                              </Action>
                            </Tooltip>
                          )}
                          {isLoading.loadingTransfer ? (
                            LoadingComp
                          ) : (
                            <Dropdown
                              visible={isShowMenuTransfer}
                              onVisibleChange={handleShowMenuTransfer}
                              overlay={menuListAgents("transfer")}
                              placement="bottomCenter"
                              trigger={["click"]}
                            >
                              <Tooltip title="Transfer">
                                <Action
                                  onClick={
                                    !isShowMenuTransfer && _onLoadAgentsOnline
                                  }
                                  active={isShowMenuTransfer}
                                >
                                  <img src={TransferIcon} alt="transfer" />
                                </Action>
                              </Tooltip>
                            </Dropdown>
                          )}

                          {isLoading.loadingConference ? (
                            LoadingComp
                          ) : (
                            <Dropdown
                              visible={isShowMenuConference}
                              onVisibleChange={handleShowMenuConference}
                              overlay={menuListAgents("conference")}
                              placement="bottomCenter"
                              trigger={["click"]}
                            >
                              <Tooltip title="Conference">
                                <Action
                                  onClick={
                                    !isShowMenuConference && _onLoadAgentsOnline
                                  }
                                  active={isShowMenuConference}
                                >
                                  <img src={ConferenceIcon} alt="conference" />
                                </Action>
                              </Tooltip>
                            </Dropdown>
                          )}

                          {isLoading.loadingConsult ? (
                            LoadingComp
                          ) : (
                            <Dropdown
                              visible={isShowMenuConsult}
                              onVisibleChange={handleShowMenuConsult}
                              overlay={menuListAgents("consult")}
                              placement="bottomCenter"
                              trigger={["click"]}
                            >
                              <Tooltip title="Consult">
                                <Action
                                  onClick={
                                    !isShowMenuConsult && _onLoadAgentsOnline
                                  }
                                  active={isShowMenuConsult}
                                >
                                  <img src={ConsultIcon} alt="consult" />
                                </Action>
                              </Tooltip>
                            </Dropdown>
                          )}

                          <Tooltip title="Numpad">
                            <Action
                              onClick={() =>
                                setIsShowNumpadInCall(!isShowNumpadIncall)
                              }
                              active={isShowNumpadIncall}
                            >
                              <img src={NumpadIcon} alt="numpad" />
                            </Action>
                          </Tooltip>
                        </Actions>
                      </CallOut>
                    ) : screenCall === "incomingCall" ? (
                      <IncomingCall>
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                          }}
                        >
                          <Avatar>
                            <img src={AvatarIcon} alt="avatar" />
                          </Avatar>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <PhoneNumber>{phoneNumber}</PhoneNumber>
                            <StatusCall>{statusInCall}</StatusCall>
                          </div>
                        </div>
                        <Actions
                          screen={screenCall}
                          style={{
                            marginTop: "12px",
                            borderTop: "1px solid #919eab3d",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <ButtonAnswerCall onClick={_onAnswerCall}>
                            {isLoading.loadingAnswerCall ? (
                              <Spin />
                            ) : (
                              <img src={AnswerCall} alt="answerCall" />
                            )}
                          </ButtonAnswerCall>
                        </Actions>
                      </IncomingCall>
                    ) : (
                      <KeyBoard>
                        <WrapInput>
                          <Input
                            value={valueInput}
                            onChange={handleChangeInput}
                          />
                          <ButtonDeleteInput onClick={() => onDeleteInput()}>
                            <img src={DeleteNumber} alt="delete" />
                          </ButtonDeleteInput>
                        </WrapInput>
                        <WrapNumber>
                          <Row>
                            <span onClick={() => onClickNumber("1")}>1</span>
                            <span onClick={() => onClickNumber("2")}>2</span>
                            <span onClick={() => onClickNumber("3")}>3</span>
                          </Row>
                          <Row>
                            <span onClick={() => onClickNumber("4")}>4</span>
                            <span onClick={() => onClickNumber("5")}>5</span>
                            <span onClick={() => onClickNumber("6")}>6</span>
                          </Row>
                          <Row>
                            <span onClick={() => onClickNumber("7")}>7</span>
                            <span onClick={() => onClickNumber("8")}>8</span>
                            <span onClick={() => onClickNumber("9")}>9</span>
                          </Row>
                          <Row>
                            <span onClick={() => onClickNumber("*")}>*</span>
                            <span onClick={() => onClickNumber("0")}>0</span>
                            <span onClick={() => onClickNumber("#")}>#</span>
                          </Row>
                        </WrapNumber>

                        <ButtonMakeCall
                          isShowMenuStatus={isShowMenuStatus}
                          onClick={() => _onMakeCall()}
                          disabled={
                            userDetail.onlyCallOutWhenReady === false &&
                            status === "Ready"
                          }
                        >
                          {isLoading.loadingMakeCall ? (
                            <Spin />
                          ) : (
                            <img src={CallIcon} alt="makeCall" />
                          )}
                        </ButtonMakeCall>
                      </KeyBoard>
                    )}
                  </Screen>
                </Wrapper>
              )}
            </Draggable>
          }
          trigger="click"
          visible={isShowNumpad}
          onVisibleChange={handleShowNumpad}
          overlayClassName="customNumpad"
        >
          <WrapStatus>
            {userDetail.use_voice_biometric && inCall && popupVoice && (
              <VoiceBiometric
                showVoice={showVoice}
                setShowVoice={setShowVoice}
                inCall={inCall}
                dataWebSocket={dataWebSocket}
              />
            )}

            {status === "Ready" ? (
              <img src={PhoneReady} alt="ready" />
            ) : (
              <img src={PhoneNotReady} alt="notReady" />
            )}
            <Infor>
              <Extension status={status}>
                <Text
                  ellipsis={{ tooltip: userDetail?.cti_extension }}
                  style={{ maxWidth: "65px" }}
                >
                  {userDetail?.cti_extension}
                </Text>
              </Extension>
              {status && (
                <Status ready={status === "Ready"}>
                  <Text>{status}</Text>
                </Status>
              )}
            </Infor>
            <img
              src={ArrowDownIcon}
              alt="down"
              style={{
                transform: isShowNumpad ? "rotate(180deg)" : "none",
                transition: "transform 0.3s",
                marginLeft: "2px",
              }}
            />
          </WrapStatus>
        </Popover>
      ) : (
        <>
          <Popover
            title={
              <span
                style={{
                  color: "#6B6B6B",
                  fontSize: "16px",
                  fontFamily: "var(--roboto-700)",
                }}
              >
                {t("common.connectCall")}
              </span>
            }
            content={
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  style={{ fontSize: "16px", fontFamily: "var(--roboto-500)" }}
                >
                  {t("common.inputExtension")}
                </span>
                <Input
                  style={{
                    width: "216px",
                    height: "32px",
                    marginTop: "8px",
                    marginBottom: "16px",
                  }}
                  value={valueExt}
                  onChange={onChangeExt}
                  onPressEnter={_onConnectExt}
                />
                <ConnectButton
                  style={{
                    width: "216px",
                    height: "32px",
                    padding: "0 15px",
                    fontSize: "16px",
                  }}
                  onClick={_onConnectExt}
                >
                  {t("common.connect")}
                </ConnectButton>
              </div>
            }
            trigger="click"
            visible={isShowConnect}
            onVisibleChange={handleShowConnect}
          >
            <ConnectButton>
              <img src={PhoneReady} alt="" style={{ marginRight: "8px" }} />
              {t("common.connect")}
            </ConnectButton>
          </Popover>

          <ModalConfirm
            title="Confirm"
            decs={t("common.extensionIsUsed")}
            method={connectExt}
            data={{
              ext: valueExt,
              force_connect: 1,
              userID: _.get(userDetail, "_id"),
            }}
            img={ImgConfirm}
            showConfirm={alreadyUseExt}
            setShowConfirm={() => dispatch(setAlreadyUseExt(false))}
          />
        </>
      )}

      <ModalConfirm
        title="Confirm"
        decs={t("common.areYouSure")}
        method={disconnectExt}
        data={{
          userID: _.get(userDetail, "_id"),
        }}
        img={ImgConfirm}
        showConfirm={showConfirmDisconnect}
        setShowConfirm={$showConfirmDisconnect}
      />
    </>
  );
}

export default withTranslation()(PopupNumpad);

const WrapStatus = styled.div`
  display: flex;
  align-items: center;
  height: 44px;
  width: fit-content;
  cursor: pointer;
  position: relative;
  padding: 0 8px;
  border-radius: 5px;
  transition: 0.2s all ease;

  &:hover {
    background: #919eab14;
    transition: 0.2s all ease;
  }

  img {
    height: fit-content;
  }
`;

const WrapStatusInPopup = styled(WrapStatus)`
  height: 100%;
  padding: 0;
  gap: 4px;
`;

const Infor = styled.div`
  display: flex;
  flex-direction: column;
  height: 44px;
  line-height: 25px;
  margin: 0 8px;
`;

const Extension = styled.div`
  height: ${({ status }) => (status ? "20px" : "unset")};
  color: #212b36;
  font-size: 14px;
  width: 100%;

  span {
    line-height: 20px;
    color: #212b36 !important;
    font-family: var(--roboto-500);
  }
`;

const ExtensionInPopup = styled(Extension)`
  span {
    line-height: unset;
  }
`;

const Status = styled.div`
  font-family: var(--roboto-500);
  font-size: 12px;
  position: relative;
  padding-left: 12px;
  line-height: 20px;

  span {
    color: ${({ ready }) => (ready ? "#0bb865" : "#FF5630")};
  }

  ::before {
    content: "";
    background: ${({ ready }) => (ready ? "#0bb865" : "#FF5630")};
    width: 8px;
    height: 8px;
    position: absolute;
    border-radius: 50%;
    top: 6px;
    left: 0;
  }
`;

const Wrapper = styled.div`
  width: 240px;
  height: ${({ screen, isShowNumpadIncall }) =>
    screen === "inCall"
      ? isShowNumpadIncall
        ? "328px"
        : "183px"
      : screen === "incomingCall"
      ? "151px"
      : "302px"};
  background: #fff;
  box-shadow: 0px 0px 38px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
`;

const Header = styled.div`
  height: 34px;
  box-shadow: 0px 0px 17px 0px #0000001a;
  padding: 0px 12px;
  border-radius: 4px 4px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const WrapExit = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    cursor: pointer;
    width: fit-content;
  }
`;

const Screen = styled.div`
  border-radius: 0 0 4px 4px;
  background-color: ${({ isShowMenuStatus }) =>
    isShowMenuStatus ? "rgba(0, 0, 0, 0.7);" : ""};
  transition: background-color 0.5s linear;
  padding: 0 12px;
`;

const KeyBoard = styled.div`
  padding: 12px 0;
`;

const MenuStatus = styled(Menu)`
  width: 216px;
`;

const MenuStatusItem = styled(Menu.Item)`
  position: relative;
  .ant-typography {
    padding-left: 20px;

    ::before {
      content: "";
      background: ${({ ready }) => (ready ? "#0bb865" : "#FF5630")};
      width: 8px;
      height: 8px;
      position: absolute;
      border-radius: 50%;
      top: 13px;
      left: 16px;
    }
  }
`;

const WrapInput = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  margin-top: ${({ isShowNumpadIncall }) =>
    isShowNumpadIncall ? "12px" : "0"};

  .ant-input {
    font-size: 16px;
    padding: 2px 11px;
    border-radius: 6px;
  }
`;

const ButtonDeleteInput = styled(Button)`
  width: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;

  :hover {
    border-color: ${(props) => props.theme.darker}!important;
  }

  :active {
    border-color: #d9d9d9;
  }

  :focus {
    border-color: #d9d9d9;
  }
`;

const WrapNumber = styled.div``;

const Row = styled.div`
  display: flex;
  justify-content: space-around;

  span {
    width: 60px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;

    :hover {
      cursor: pointer;
      background: #e8eaeb;
    }
  }
`;

const ButtonMakeCall = styled(Button)`
  margin-top: 8px;
  background: #0bb865;
  border-color: #0bb865;
  width: 100%;
  padding: 8px 16px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${({ isShowMenuStatus }) => (isShowMenuStatus ? "0.3" : "1")};

  .ant-spin {
    display: flex;
  }

  .ant-spin-dot-item {
    background-color: #fff;
  }

  :hover {
    background: #0c9654 !important;
    border-color: #0c9654 !important;
  }

  :active {
    background: #0bb865;
    border-color: #0bb865;
  }

  :focus {
    background: #0bb865;
    border-color: #0bb865;
  }
`;

const CallOut = styled.div`
  display: flex;
  flex-direction: column;
`;

const IncomingCall = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 0;
`;

const Avatar = styled.div``;

const PhoneNumber = styled.div`
  font-size: 16px;
  font-family: var(--roboto-500);
  color: #212b36;
`;

const StatusCall = styled.div`
  color: #637381;
  font-size: 12px;
`;

const Duration = styled.div`
  color: #637381;
  font-size: 12px;
`;

const ButtonDeclineCall = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  background: #c62828;
  border-radius: 6px;

  .ant-spin {
    display: flex;
  }

  .ant-spin-dot-item {
    background-color: #fff;
  }

  :hover {
    background: #9d1212 !important;
    border-color: #9d1212 !important;
  }

  :active {
    background: #c62828;
    border-color: #c62828;
  }

  :focus {
    background: #c62828;
    border-color: #c62828;
  }
`;

const ButtonAnswerCall = styled(ButtonDeclineCall)`
  background: #0bb865;
  width: 100px;

  :hover {
    background: #0c9654 !important;
    border-color: #0c9654 !important;
  }

  :active {
    background: #0bb865;
    border-color: #0bb865;
  }

  :focus {
    background: #0bb865;
    border-color: #0bb865;
  }
`;

const Hotline = styled.div`
  color: #212b36;
  border-top: 1px solid #919eab3d;
  border-bottom: 1px solid #919eab3d;
  padding: 4px 0;
  width: 100%;
  text-align: center;
`;

const Actions = styled.div`
  padding-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .ant-spin-dot-item {
    background-color: ${(props) => props.theme.main};
  }
`;

const Action = styled.div`
  width: 36px;
  height: 30px;
  border-radius: 6px;
  border: 1px solid #dce0e4;
  background: ${({ active }) => (active ? "#0177FF" : "#fff")};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  img {
    filter: ${({ active }) => (active ? "brightness(200)" : "unset")};
  }

  :hover {
    background: #40a9ff;

    img {
      filter: brightness(200);
    }
  }
`;

const ActionMini = styled(Action)`
  width: 32px;
  height: 24px;
`;

const MenuTransfer = styled.div`
  background-color: #fff;
  width: 638px;
  padding: 16px;
  border-radius: 10px;

  .ant-table-thead > tr > th {
    padding: 8.5px 16px;
  }

  .ant-table-tbody > tr > td {
    padding: 5px 16px;
  }
`;

const TitleTransfer = styled.div`
  color: #2c2c2c;
  font-family: var(--roboto-700);
  font-size: 18px;
  margin-bottom: 10px;
`;

const ActionTransfer = styled.div`
  width: 31px;
  height: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  :hover {
    background: #eeeeee;
    border-radius: 2px;
  }
`;

const WrapperMini = styled.div`
  display: flex;
  align-items: center;
  width: 443px;
  height: 56px;
  background: #ffffff;
  box-shadow: 0px 0px 38px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 8px 12px;
  gap: 8px;
`;

const AvatarMini = styled(Avatar)``;

const DurationMini = styled(Duration)`
  margin-bottom: 0;
  margin-right: 32px;
`;

const ActionsMini = styled(Actions)`
  padding: 0;
  gap: 8px;
`;

const ButtonDeclineCallMini = styled(ButtonDeclineCall)`
  width: 32px;
  height: 24px;
`;

// const TextStatus = styled.div`
//   width: 60px;
//   display: -webkit-box;
//   text-overflow: ellipsis;
//   -webkit-line-clamp: 1;
//   -webkit-box-orient: vertical;
//   overflow: hidden;
//   color: #000;
// `;

const ConnectButton = styled(Button)`
  width: 121px;
  height: 44px;
  font-family: var(--roboto-700);
  background: ${(props) => props.theme.main};
  color: #fff;
  border-radius: 5px;

  :hover {
    background: ${(props) => props.theme.darker}!important;
    color: #fff !important;
  }

  :active {
    background: ${(props) => props.theme.main};
    color: #fff;
  }

  :focus {
    background: ${(props) => props.theme.main};
    color: #fff;
  }
`;

const WrapSearch = styled.div`
  width: 250px;
  padding: 8px;

  .ant-select {
    width: 100%;
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 32px;
  }
`;
